import { IconSearch } from '../../../../../../shared/icon/icon'

// A folder that isn't in its area once the area's list has loaded (deleted,
// moved to another organization, an old link): the grid's empty state says
// so, with the way to the area's top, instead of "This category is empty"
// under the area's own name (audit F10). `section`: the area's entry in
// shared/navigation/sections.js.
export const folderNotFound = section => ({
  Icon: IconSearch,
  title: 'Folder not found',
  message: 'There is no such folder here. It may have been deleted or moved, or the link may be wrong.',
  action: { label: `Go to ${section.text}`, to: section.url }
})
